const getPWADisplayMode = () => {
  const isStandalone = window.matchMedia('(display-mode: standalone)').matches;

  let ret;
  if (document.referrer.startsWith('android-app://')) {
    ret = 'twa'; // Trusted Web Activity (TWA) on Android
  } else if (navigator.standalone
              || isStandalone) {
    ret = 'standalone';
  } else ret = 'browser';

  // console.log(`getPWADisplayMode ${ret}`);
  return ret;
};

export default getPWADisplayMode;
